import { render } from "./profiletab.vue?vue&type=template&id=1299ac24&scoped=true"
import script from "./profiletab.vue?vue&type=script&lang=js"
export * from "./profiletab.vue?vue&type=script&lang=js"

import "./profiletab.vue?vue&type=style&index=0&id=1299ac24&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1299ac24"]])

export default __exports__